<template>
    <div>
        <div class="row">
            <!-- <div class="col-md-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'home' }">{{
                  $t("inicio")
                }}</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ $t("gestionDeGastos") }}
              </li>
            </ol>
          </nav>
        </div> -->

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness"><strong>{{ $t("negocio") }}</strong></label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambiarNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.idBusiness" 
                                        :label="business.establishmentName"
                                        :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <template v-if="permiso">
                            <!-- <div class="col-md-3">
                  <div class="form-group">
                    <label for="listBusiness"
                      ><strong>{{ $t("proveedores") }}</strong></label
                    >
  
                    <el-select
                      class="select-default"
                      size="large"
                      v-model="idSupplier"
                      filterable
                      :placeholder="$t('seleccionaProveedor')"
                      @change="getGastosNegocio(true)"
                    >
                      <el-option
                        v-for="su in listProveedores"
                        class="select-primary"
                        :value="su.id"
                        :label="su.name"
                        :key="su.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div> -->

                            <!-- <div class="col-md-2">
                  <div class="form-group">
                    <label>{{ $t("fechaInicio") }}</label>
                    <datetime
                      :value-zone="timezoneId"
                      :auto="true"
                      class="theme-numier"
                      format="dd-MM-yyyy"
                      :title="$t('fechaInicio')"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="datefrom"
                    ></datetime>
                  </div>
                </div> -->

                            <!-- <div class="col-md-2">
                  <div class="form-group">
                    <label>{{ $t("fechaFin") }}</label>
                    <datetime
                      :auto="true"
                      class="theme-numier"
                      :value-zone="timezoneId"
                      :title="$t('fechaFin')"
                      format="dd-MM-yyyy"
                      :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                      input-class="form-control"
                      v-model="dateto"
                    ></datetime>
                  </div>
                </div> -->

                            <div class="col-md-2">
                                <label>&nbsp;</label>
                                <div class="form-group">
                                    <button class="btn btn-primary" @click="getGastosAfectados()">
                                        <img src="static/img/sync.gif" alt="" v-if="loading" width="15" />
                                        {{ $t("consultar") }}
                                    </button>

                                    <!-- <el-checkbox v-model="filtrarPorFecha"
                      >{{ $t("filtrarPorFecha") }}
                      <i
                        v-tooltip.top-center="
                          'Si esta opción está activada, filtrará por dias naturales, no por fecha de apertura de caja.'
                        "
                        class="fa fa-info-circle"
                      ></i>
                    </el-checkbox> -->
                                </div>
                            </div>

                            <!-- <div class="col-md-4">
                  <label
                    ><strong>{{ $t("procedencia") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="procedencia"
                      :label="2"
                    >
                      {{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="procedencia"
                      :label="1"
                    >
                      {{ $t("deCaja") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="procedencia"
                      :label="0"
                    >
                      {{ $t("fueraDeCaja") }}
                    </el-radio>
                  </div>
                </div>
  
                <div class="col-md-4">
                  <label
                    ><strong>{{ $t("tipo") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="tipo"
                      :label="0"
                      >{{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="tipo"
                      label="A"
                      >{{ $t("albaran") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="tipo"
                      label="F"
                      >{{ $t("factura") }}
                    </el-radio>
                  </div>
                </div>
  
                <div class="col-md-4">
                  <label
                    ><strong>{{ $t("contabilizado") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="contabilizado"
                      :label="-1"
                    >
                      {{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="contabilizado"
                      :label="1"
                    >
                      {{ $t("si") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="contabilizado"
                      :label="0"
                    >
                      {{ $t("no") }}
                    </el-radio>
                  </div>
                </div>
  
                <div class="col-md-6">
                  <label
                    ><strong>{{ $t("formaDePago") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="formaPago"
                      :label="-1"
                      >{{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="formaPago"
                      :label="0"
                    >
                      {{ $t("transferencia") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="formaPago"
                      :label="1"
                    >
                      {{ $t("domiciliacion") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="formaPago"
                      :label="2"
                    >
                      {{ $t("efectivo") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="formaPago"
                      :label="3"
                    >
                      {{ $t("tarjeta") }}
                    </el-radio>
                  </div>
                </div>
  
                <div class="col-md-3">
                  <label
                    ><strong>{{ $t("pendientePago") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="pendientePago"
                      :label="-1"
                    >
                      {{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="pendientePago"
                      :label="true"
                    >
                      {{ $t("si") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="pendientePago"
                      :label="false"
                    >
                      {{ $t("no") }}
                    </el-radio>
                  </div>
                </div>
  
                <div class="col-md-3">
                  <label
                    ><strong>{{ $t("verificado") }}</strong></label
                  >
                  <div class="form-group">
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="verificado"
                      :label="-1"
                    >
                      {{ $t("todos") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="verificado"
                      :label="1"
                    >
                      {{ $t("si") }}
                    </el-radio>
                    <el-radio
                      @change="getGastosNegocio(true)"
                      v-model="verificado"
                      :label="0"
                    >
                      {{ $t("no") }}
                    </el-radio>
                  </div>
                </div> -->
                        </template>
                    </div>
                </div>
            </div>
            <!-- <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template> -->
            <div class="col-md-12">
                <div class="card">
                    <template>


                        <div v-if="listAffectedGastos.length > 0" class="table-responsive">
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                    <tr>
                                        <!--NUEVOS CAMPOS-->
                                        <th style="width: 20%;">

                                            <span>
                                                Referencia
                                            </span>
                                        </th>

                                        <th style="width: 15%;">
                                            <span>
                                                Tipo de gasto
                                            </span>
                                        </th>

                                        <th style="width: 15%;">
                                            <span>
                                                Procedencia
                                            </span>
                                        </th>

                                        <th style="width: 15%;">
                                            <span>
                                                Proveedor
                                            </span>
                                        </th>

                                        <!--FIN NUEVOS CAMPOS-->

                                        <th style="width: 15%;">
                                            <span>
                                                Fecha
                                            </span>
                                        </th>








                                        <th style="width: 15%;">
                                            <span>
                                                Importe
                                            </span>
                                        </th>







                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="obj in listAffectedGastos">
                                        <!--NUEVOS CAMPOS-->

                                        <!-- referencia -->
                                        <td>{{ obj.referencia }}</td>

                                        <!-- tipoGasto -->
                                        <td>
                                            <span v-if="obj.type === 'F'">
                                                Factura</span>
                                            <span v-else-if="obj.type === 'A'">
                                                Albarán</span>
                                        </td>



                                        <!-- tipoGasto -->
                                        <td>
                                            <span v-if="obj.fromCash == 0">
                                                Fuera de caja</span>
                                            <span v-else-if="obj.fromCash == 1">
                                                Caja</span>
                                        </td>

                                        <!-- proveedor -->
                                        <td>{{ obj.supplierName }}</td>

                                        <!-- fechagasto -->
                                        <td>
                                            <span>{{
                                                obj.date | parseDate
                                            }}</span>
                                        </td>



                                        <td>
                                            <input v-model="obj.importe" class="form-control"
                                                placeholder="Introduzca el importe" />
                                        </td>

                                        <td style="text-align: center;">
                                            <span>

                                                <i @click="saveGasto(obj)" class="fa-solid fa-floppy-disk text-success">
                                                   
                                                </i>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- <tfoot>
                    <tr class="table-success">
                      <td>
                        <strong>{{ $t("total") }}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="text-right">
                        <strong>{{ getTotalBase | currency }}</strong>
                      </td>
                      <td></td>
                      <td class="text-right">
                        <strong>{{ getTotalPrecio | currency }}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td v-if="identificadorContable"></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td v-if="tieneSage"></td>
                    </tr>
                  </tfoot> -->
                            </table>
                        </div>
                    </template>
                    <template v-if="!listAffectedGastos.length > 0">
              <div class="alert alert-danger" role="alert">
                {{ $t("noHay") }} <strong>{{ $t("gastos") }}</strong>
              </div>
            </template>
                </div>
            </div>
        </div>

        <!-- <modal
        name="modal-open-inventario"
        :adaptive="true"
        width="900px"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("entradaAlmacen") }}</h4>
          </div>
          <div class="modal-body">
            <div>
              <div
                v-if="inventario.subproducts.length > 0"
                class="table-responsive"
              >
                <div class="checkbox">
                  <label v-if="inventario.ivaIncluded == 0">
                    <input type="checkbox" disabled />
                    {{ $t("preciosIVAIncluido") }}
                  </label>
                  <label v-else>
                    <input type="checkbox" disabled checked />
                    {{ $t("preciosIVAIncluido") }}
                  </label>
                </div>
  
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("ref") }}.</th>
                      <th>{{ $t("nombre") }}</th>
                      <th>{{ $t("uds") }}.</th>
                      <th>{{ $t("partes") }}</th>
                      <th>{{ $t("precioSinIVA") }}</th>
                      <th>{{ $t("IVA") }}</th>
                      <th>{{ $t("precio") }}</th>
                      <th>{{ $t("total") }}</th>
                      <th>{{ $t("porcentajeDto") }}</th>
                      <th>{{ $t("importe") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="sub in inventario.subproducts">
                      <td>{{ sub.cod_ean }}<br /></td>
                      <td>{{ sub.nameSubproduct }}</td>
                      <td>{{ sub.ud }}</td>
  
                      <td v-if="sub.escandallo > 1">{{ sub.partes }}</td>
                      <td v-else>-</td>
                      <td>
                        {{ sub.price | parseIVA(sub.iva) | currencyGastos }}
                      </td>
                      <td>{{ sub.iva }}</td>
                      <td style="white-space: nowrap">
                        {{ sub.price | currencyGastos }}
                      </td>
                      <td style="white-space: nowrap" v-if="sub.ivaIncluded">
                        {{ (sub.price * sub.ud) | currencyGastos }}
                      </td>
                      <td style="white-space: nowrap" v-else>
                        {{ sub.total | parseBase(sub.iva) | currencyGastos }}
                      </td>
                      <td>{{ sub.dto }}%</td>
                      <td style="white-space: nowrap">
                        {{ sub.total | currencyGastos }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="alert alert-danger" role="alert">
                {{ $t("estaEntradaNoContieneNingunSubproducto") }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-window-close"></i>
                {{ $t("cerrar") }}
              </button>
            </div>
          </div>
        </div>
      </modal> -->

        <!-- <modal
        name="modal-seleccionar-forma-pago"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div class="modal-header">
          <h4 style="margin: 0px; text-align: center">
            {{ $t("seleccioneUnaFormaDePagoParaElGasto") }}
          </h4>
        </div>
        <div class="modal-body">
          <el-select
            v-model="formaDePagoDeConversion"
            :placeholder="$t('seleccioneUnaFormaDePago')"
            class="col-md-12 select-default"
            filterable
          >
            <el-option
              v-for="formaDePago in optionsFormaPago"
              :key="formaDePago.value"
              :label="formaDePago.label"
              :value="formaDePago.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="cerrarModal()" class="btn btn-danger">
              <i class="fas fa-window-close"></i>
              {{ $t("cerrar") }}
            </button>
            <button
              @click="(fromFormaPago = true), openModalConvertirAlbaran()"
              class="btn btn-primary"
            >
              <i class="fas fa-check"></i>
              {{ $t("aceptar") }}
            </button>
          </div>
        </div>
      </modal> -->

        <!-- <modal
        name="modal-convertir-albaran"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("convertirAlbaranEnFactura") }}</h4>
          </div>
          <div class="modal-body">
            <div>
              <div class="form-group">
                <label
                  ><strong
                    >{{ $t("refFactura") }}
                    <span style="color: red">*</span></strong
                  ></label
                >
                <input
                  v-model="refFactura"
                  class="form-control"
                  placeholder="Introduzca la ref. de la nueva factura"
                />
                <label
                  ><strong
                    >Fecha de factura <span style="color: red">*</span></strong
                  ></label
                >
  
                <el-date-picker
                  v-model="fechaFactura"
                  type="date"
                  format="dd-MM-yyyy"
                  prefix-icon="fas fa-calendar-alt"
                  clear-icon="fas fa-times-circle"
                  placeholder="Introduzca la fecha de esta factura"
                ></el-date-picker>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-window-close"></i>
                {{ $t("cerrar") }}
              </button>
              <button @click="convertirAlbaran()" class="btn btn-primary">
                <i class="fas fa-random"></i>
                {{ $t("convertir") }}
              </button>
            </div>
          </div>
        </div>
      </modal> -->

        <!-- <modal
        name="modal-albaranes-de-factura"
        :width="900"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("albaranesDeLaFactura") }}</h4>
          </div>
          <div class="modal-body">
            <div>
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>
                      {{ $t("fecha") }}
                    </th>
  
                    <th>
                      {{ $t("base") }}
                    </th>
                    <th>
                      {{ $t("importe") }}
                    </th>
                    <th>
                      {{ $t("referencia") }}
                    </th>
  
                    <th>
                      {{ $t("formaDePago") }}
                    </th>
  
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="obj in listAlbaranesDeFactura">
                    <td style="width: 10%">{{ obj.date | parseDateMin }}</td>
                    <td align="right" style="width: 10%">
                      {{ obj.base | currency }}
                    </td>
                    <td align="right" style="width: 10%">
                      {{ obj.total | currency }}
                    </td>
                    <td>{{ obj.ref_alb }}</td>
                    <td>
                      <span v-if="obj.formaPago === '0'">{{
                        $t("tranferencia")
                      }}</span>
                      <span v-else-if="obj.formaPago === '1'">{{
                        $t("domiciliacion")
                      }}</span>
                      <span v-else-if="obj.formaPago === '3'">{{
                        $t("tarjeta")
                      }}</span>
                      <span v-else>{{ $t("efectivo") }}</span>
                    </td>
                    <td class="text-center">
                      <span
                        v-tooltip.top-center="$t('verDetalles')"
                        @click="rutas(1, obj)"
                      >
                        <i class="far fa-eye"></i
                      ></span>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
  
                    <td class="text-right">
                      <strong>{{ getTotalAlbaranBase | currency }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ getTotalAlbaranPrecio | currency }}</strong>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button @click="cerrarModal()" class="btn btn-danger">
                <i class="fas fa-window-close"></i>
                {{ $t("volver") }}
              </button>
            </div>
          </div>
        </div>
      </modal> -->

        <!-- LOLO -->
        <!-- <modal
        name="modal-conta"
        :width="400"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("exportarContabilidad") }}</h4>
        </div>
        <div class="modal-body">
          <div class="d-flex">
            <div class="col-6">
              <label for="idStart"><strong>Primer id</strong></label>
              <div class="form-group">
                <vue-numeric
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  separator= "."
                  @keydown.native="$methods.evitarComasDecimales"
                  id="idStart"
                  v-model="idStart"
                ></vue-numeric>
              </div>
            </div>
            <div class="col-6">
              <label for="idEnd"><strong>Último id</strong></label>
              <div class="form-group">
                <vue-numeric
                  id="idEnd"
                  v-model="idEnd"
                  type="text"
                  class="form-control"
                  currency-symbol-position="suffix"
                  separator= "."
                  @keydown.native="$methods.evitarComasDecimales"
                ></vue-numeric>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="closeContModal()" class="btn btn-danger">
              <i class="fas fa-window-close"></i>
              {{ $t("volver") }}
            </button>
            <button @click="exportConta()" class="btn btn-primary">
              <i class="fa fa-check"></i>
              {{ $t("exportar") }}
            </button>
          </div>
        </div>
      </modal> -->
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
//import Chart from '../../../../node_modules/chart.js/src/chart';
import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Button,
    Radio,
    CheckboxGroup,
    Checkbox,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import { Loading } from "element-ui";
import { ifft } from "mathjs";
import { mapState } from "vuex";
import download from "downloadjs";

export default {
    created() {
        this.loadingGeneral = Loading.service({ text: this.$t("cargandoGastos") });
        this.$store.dispatch("setNameRoute", this.$i18n.t("gestionDeGastos"));
        this.getAffectedBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;
        }
    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Radio.name]: Radio,
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
    },
    data() {
        return {
            loading: false,
            loadingGeneral: null,
            datefrom: new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
            ).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: 0,
            value4: [
                new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                new Date(),
            ],
            list: ["-"],
            mode: 1,
            procedencia: 2,
            $Chart: null,
            objectChart: null,
            contador: 0,
            inventario: {
                subproducts: [],
                ivaIncluded: 0,
            },
            idSupplier: 0,
            listProveedores: [],
            tipo: 0,
            objGasto: 0,
            contabilizado: -1,
            formaPago: -1,
            identificadorContable: false,
            idStart: 0,
            idEnd: 0,
            //ORDENAR
            ordenarFecha: 0,
            ordenarProveedor: 0,
            ordenarBase: 0,
            ordenarImporteIVA: 0,
            ordenarImporte: 0,
            ordenarReferencia: 0,
            ordenarTipo: 0,
            ordenarProcedencia: 0,
            ordenarFormaDePago: 0,
            ordenarEntrAlmac: 0,
            ordenarContab: 0,
            ordenarNombreTpv: 0,
            ordenarNombreApellido: 0,
            ordenarNombreOperario: 0,
            ordenarId: 0,
            ordenarPago: 0,
            ordenarVencimiento: 0,

            //CONVERIR ALBARAN
            listConvertir: [],
            idSupplierConvertir: 0,

            listFacturas: [],
            listAffectedGastos: [],
            idSupplierConvert: [],
            query: "",
            listFacturasIdes: [],
            refFactura: "",
            fechaFactura: "",
            horaFactura: "",

            listAlbaranesDeFactura: [],
            respuesta: true,
            convertirAlbaranes: false,

            filtrarPorFecha: true,
            listIdentificadorContable: [],

            formaDePagoDeConversion: null,
            fromFormaPago: false,
            optionsFormaPago: [
                {
                    value: 0,
                    label: "Transferencia",
                },
                {
                    value: 1,
                    label: "Domiciliación",
                },
                {
                    value: 2,
                    label: "Efectivo",
                },
                {
                    value: 3,
                    label: "Tarjeta",
                },
            ],
            tieneSage: false,
            fechaVencimiento: "",
            verificado: -1,
            pendientePago: -1,
        };
    },
    computed: {
        ...mapState(["permiso"]),
        timezoneId() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
        fechahorafactura() {
            return new Date(this.fechaFactura).getTime() / 1000; // + " " + this.horaFactura
        },
        urlExportPDF() {
            /*  return "../api/public/index.php/suppliers/exportGastosSupplier/PDF?idBusiness=" + this.idBusiness   + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
             */
            return (
                this.$store.getters.apiUrl +
                "/gastos/exportGastos/PDF?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                this.mode +
                "&idSupplier=" +
                this.idSupplier +
                "&filtrarPorFecha=" +
                this.filtrarPorFecha +
                "&datefrom=" +
                moment(this.datefrom).startOf("day").unix() +
                "&dateto=" +
                moment(this.dateto).endOf("day").unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },
        urlExportExcel() {
            /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
             */
            return (
                this.$store.getters.apiUrl +
                "/gastos/exportGastos/Excel?idBusiness=" +
                this.idBusiness +
                "&procedencia=" +
                this.procedencia +
                "&mode=" +
                this.mode +
                "&idSupplier=" +
                this.idSupplier +
                "&filtrarPorFecha=" +
                this.filtrarPorFecha +
                "&datefrom=" +
                moment(this.datefrom).startOf("day").unix() +
                "&dateto=" +
                moment(this.dateto).endOf("day").unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },

        getBaseTotal() {
            this.d.subproduct.forEach(function (d) {
                total += parseFloat(d.baseImpDto);
            });
            return total;
        },
        getTotalAlbaranPrecio() {
            let total = 0;
            this.listAlbaranesDeFactura.forEach(function (d) {
                total += parseFloat(d.total);
            });
            return total;
        },
        getTotalAlbaranBase() {
            let total = 0;
            this.listAlbaranesDeFactura.forEach(function (d) {
                total += parseFloat(d.base);
            });
            return total;
        },

        getTotalPrecio() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.price;
            });
            return total;
        },
        getTotalBase() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.base;
            });
            return total;
        },
    },
    methods: {
        accion(x) {
            if (this.listConvertir.length > 0) {
                this.idSupplierConvertir = x;
            } else {
                this.idSupplierConvertir = 0;
            }
        },

        seleccionarTodosAlbaranes() {
            if (this.idSupplierConvertir != 0) {
                this.listConvertir = [];

                this.list.forEach((gasto) => {
                    if (gasto.type === "A") {
                        if (gasto.supplierId == this.idSupplierConvertir) {
                            this.listConvertir.push(gasto.idCab);
                        }
                    }
                });
            }
        },

        cambiarNegocio() {
            this.getProveedores();
            this.idSupplier = 0;
            this.listProveedores = [];
            this.idSupplierConvert = 0;
            this.listFacturasIdes = [];
            this.query = "";
        },

        getConfigIdentificador() {
            let vm = this;

            let configIdentificador = "100";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idBusiness: this.idBusiness,
                    numConfig: configIdentificador,
                },

                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            this.axios
                .get(
                    this.$store.getters.apiUrl + "general/checkConfigByBusiness",
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.identificadorContable = response.data.result;

                        vm.getTieneSage();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: vm.$t("error"),
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getTieneSage() {
            if (this.idBusiness.length > 0) {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        numConfig: "36",
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response == true) {
                            vm.respuesta = true;
                            vm.tieneSage = true;
                        }

                        vm.loading = false;
                        vm.loadingGeneral.close();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        searchAlbaranes() {
            if (this.query !== "") {
                const controller = "  Albaranes/" + this.query;
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        idSupplier: this.idSupplierConvert,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                let vm = this;
                this.axios
                    .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.listFacturas = response.data.result;
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },

        convertirAlbaran() {
            if (this.refFactura !== "") {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };
                var params = {
                    listFacturasIdes: this.listConvertir,
                    idBusiness: this.idBusiness,
                    refFactura: this.refFactura,
                    fechaFactura: this.fechahorafactura,
                    idSupplier: this.idSupplierConvertir,
                    formaDePago: this.formaDePagoDeConversion,
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                let controller = "convertirAlbaran";
                this.axios
                    .post(
                        this.$store.getters.apiUrl + "gastos/" + controller,
                        params,
                        config
                    )
                    .then(function (response) {
                        if (response.data.response) {
                            let notify = vm.$t("finalizada");
                            vm.$notify({
                                message:
                                    vm.$t("conversion") +
                                    " " +
                                    notify +
                                    " " +
                                    vm.$t("correctamente"),
                                icon: "nc-icon nc-check-2",
                                timeout: 2000,
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });

                            vm.$modal.hide("modal-convertir-albaran");
                            vm.getGastosNegocio();
                            vm.convertirAlbaranes = false;
                            vm.idSupplierConvertir = 0;
                            vm.listConvertir = [];
                            vm.idSupplierConvert = 0;
                            vm.listFacturasIdes = [];
                            vm.query = "";
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            } else {
                swal({
                    title: this.$t("atencion"),
                    text: this.$t("relleneLosCamposObligatorios"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },

        getAlbaranesByFacturas(idCab) {
            const controller = "getAlbaranesByFacturas";
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    idCab: idCab,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listAlbaranesDeFactura = response.data.result;
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        openModalConvertirAlbaran() {
            //Comprobar la forma de pago de listConvertir (this.list)

            this.$modal.hide("modal-seleccionar-forma-pago");

            if (this.formaDePagoDeConversion != null && this.fromFormaPago) {
                this.$modal.show("modal-convertir-albaran");
                this.fromFormaPago = false;
            } else {
                this.fromFormaPago = false;

                let formasDePago = [];

                this.listConvertir.forEach((gastoConvertir) => {
                    this.list.forEach((gasto) => {
                        if (gastoConvertir == gasto.idCab) {
                            if (!formasDePago.includes(gasto.formaPago)) {
                                formasDePago.push(gasto.formaPago);
                            }
                        }
                    });
                });

                if (formasDePago.length == 1) {
                    this.formaDePagoDeConversion = formasDePago[0];
                    this.$modal.show("modal-convertir-albaran");
                } else {
                    this.$modal.show("modal-seleccionar-forma-pago");
                }
            }
        },

        verificarTodo() {
            swal({
                title: this.$t("estaSeguroDeVerificarTodosLosGastos"),
                text: this.$t("estaOperacionNoSePuedeDeshacer"),
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("siVerificarGastos"),
                cancelButtonText: this.$t("cancelar"),
                buttonsStyling: true,
            }).then((result) => {
                if (result.value) {
                    this.verificarTodosLosGastos();
                }
            });
        },

        openModalAlbaranesFactura(idCab) {
            this.getAlbaranesByFacturas(idCab);

            this.$modal.show("modal-albaranes-de-factura");
        },

        sortedArrayASC: function (nameAtributo) {
            switch (nameAtributo) {
                case 1:
                    this.ordenarFecha = 1;

                    function compareFecha(a, b) {
                        if (a.date.toUpperCase() < b.date.toUpperCase()) return -1;
                        if (a.date.toUpperCase() > b.date.toUpperCase()) return 1;
                        return 0;
                    }

                    return this.list.sort(compareFecha);

                case 2:
                    this.ordenarProveedor = 1;

                    function compareProveedor(a, b) {
                        if (a.supplierName < b.supplierName) return -1;
                        if (a.supplierName > b.supplierName) return 1;
                        return 0;
                    }

                    return this.list.sort(compareProveedor);

                case 3:
                    this.ordenarBase = 1;

                    function compareBase(a, b) {
                        if (a.base < b.base) return -1;
                        if (a.base > b.base) return 1;
                        return 0;
                    }

                    return this.list.sort(compareBase);

                case 4:
                    this.ordenarImporte = 1;

                    function compareImporte(a, b) {
                        if (a.price < b.price) return -1;
                        if (a.price > b.price) return 1;
                        return 0;
                    }

                    return this.list.sort(compareImporte);

                case 5:
                    this.ordenarReferencia = 1;

                    function compareReferencia(a, b) {
                        if (a.ref < b.ref) return -1;
                        if (a.ref > b.ref) return 1;
                        return 0;
                    }

                    return this.list.sort(compareReferencia);

                case 6:
                    this.ordenarTipo = 1;

                    function compareTipo(a, b) {
                        if (a.type < b.type) return -1;
                        if (a.type > b.type) return 1;
                        return 0;
                    }

                    return this.list.sort(compareTipo);

                case 7:
                    this.ordenarProcedencia = 1;

                    function compareProcedencia(a, b) {
                        if (a.fromCash < b.fromCash) return -1;
                        if (a.fromCash > b.fromCash) return 1;
                        return 0;
                    }

                    return this.list.sort(compareProcedencia);

                case 8:
                    this.ordenarFormaDePago = 1;

                    function compareFormaPago(a, b) {
                        if (a.formaPago < b.formaPago) return -1;
                        if (a.formaPago > b.formaPago) return 1;
                        return 0;
                    }

                    return this.list.sort(compareFormaPago);

                case 9:
                    this.ordenarContab = 1;

                    function compareContabilizado(a, b) {
                        if (a.contabilizado < b.contabilizado) return -1;
                        if (a.contabilizado > b.contabilizado) return 1;
                        return 0;
                    }

                    return this.list.sort(compareContabilizado);

                case 10:
                    this.ordenarNombreTpv = 1;

                    function compareNombreTpv(a, b) {
                        if (a.nombreTpv < b.nombreTpv) return -1;
                        if (a.nombreTpv > b.nombreTpv) return 1;
                        return 0;
                    }

                    return this.list.sort(compareNombreTpv);

                case 11:
                    this.ordenarNombreOperario = 1;

                    function compareOperario(a, b) {
                        if (a.nombreOperario < b.nombreOperario) return -1;
                        if (a.nombreOperario > b.nombreOperario) return 1;
                        return 0;
                    }

                    return this.list.sort(compareOperario);
                case 12:
                    this.ordenarImporteIVA = 1;
                    //TODO
                    function compareImporteIVA(a, b) {
                        if (a.importeIVA < b.importeIVA) return -1;
                        if (a.importeIVA > b.importeIVA) return 1;
                        return 0;
                    }

                    return this.list.sort(compareImporteIVA);

                case 13:
                    this.ordenarId = 1;
                    function compareIdentificadorContable(a, b) {
                        if (parseInt(a.identificador) < parseInt(b.identificador))
                            return -1;
                        if (parseInt(a.identificador) > parseInt(b.identificador)) return 1;
                        return 0;
                    }

                    return this.list.sort(compareIdentificadorContable);

                case 14:
                    this.ordenarPago = 1;

                    function comparePendientePago(a, b) {
                        if (a.pendientePago === b.pendientePago) {
                            return 0;
                        }
                        if (a.pendientePago) {
                            return 1;
                        }
                        return -1;
                    }

                    return this.list.sort(comparePendientePago);
                case 15:
                    this.ordenarVencimiento = 1;

                    function compareVencimiento(a, b) {
                        if (
                            a.dateVencimiento.toUpperCase() < b.dateVencimiento.toUpperCase()
                        )
                            return -1;
                        if (
                            a.dateVencimiento.toUpperCase() > b.dateVencimiento.toUpperCase()
                        )
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareVencimiento);

                case 16:
                    this.ordenarEntrAlmac = 1;

                    function compareAlmacen(a, b) {
                        if (a.generateWarehouse < b.generateWarehouse) return -1;
                        if (a.generateWarehouse > b.generateWarehouse) return 1;
                        return 0;
                    }

                    return this.list.sort(compareAlmacen);
            }
        },
        sortedArrayDESC: function (nameAtributo) {
            switch (nameAtributo) {
                case 1:
                    this.ordenarFecha = 0;

                    function compareFecha(a, b) {
                        if (a.date.toUpperCase() > b.date.toUpperCase()) return -1;
                        if (a.date.toUpperCase() < b.date.toUpperCase()) return 1;
                        return 0;
                    }

                    return this.list.sort(compareFecha);

                case 2:
                    this.ordenarProveedor = 0;

                    function compareProveedor(a, b) {
                        if (a.supplierName > b.supplierName) return -1;
                        if (a.supplierName < b.supplierName) return 1;
                        return 0;
                    }

                    return this.list.sort(compareProveedor);

                case 3:
                    this.ordenarBase = 0;

                    function compareBase(a, b) {
                        if (a.base > b.base) return -1;
                        if (a.base < b.base) return 1;
                        return 0;
                    }

                    return this.list.sort(compareBase);

                case 4:
                    this.ordenarImporte = 0;

                    function compareImporte(a, b) {
                        if (a.price > b.price) return -1;
                        if (a.price < b.price) return 1;
                        return 0;
                    }

                    return this.list.sort(compareImporte);

                case 5:
                    this.ordenarImporte = 0;

                    function compareReferencia(a, b) {
                        if (a.ref > b.ref) return -1;
                        if (a.ref < b.ref) return 1;
                        return 0;
                    }

                    return this.list.sort(compareReferencia);

                case 6:
                    this.ordenarTipo = 0;

                    function compareTipo(a, b) {
                        if (a.type > b.type) return -1;
                        if (a.type < b.type) return 1;
                        return 0;
                    }

                    return this.list.sort(compareTipo);

                case 7:
                    this.ordenarProcedencia = 0;

                    function compareProcedencia(a, b) {
                        if (a.fromCash > b.fromCash) return -1;
                        if (a.fromCash < b.fromCash) return 1;
                        return 0;
                    }

                    return this.list.sort(compareProcedencia);

                case 8:
                    this.ordenarFormaDePago = 0;

                    function compareFormaPago(a, b) {
                        if (a.formaPago > b.formaPago) return -1;
                        if (a.formaPago < b.formaPago) return 1;
                        return 0;
                    }

                    return this.list.sort(compareFormaPago);

                case 9:
                    this.ordenarContab = 0;

                    function compareContabilizado(a, b) {
                        if (a.contabilizado > b.contabilizado) return -1;
                        if (a.contabilizado < b.contabilizado) return 1;
                        return 0;
                    }

                    return this.list.sort(compareContabilizado);

                case 10:
                    this.ordenarNombreTpv = 0;

                    function compareNombreTpv(a, b) {
                        if (a.nombreTpv > b.nombreTpv) return -1;
                        if (a.nombreTpv < b.nombreTpv) return 1;
                        return 0;
                    }

                    return this.list.sort(compareNombreTpv);

                case 11:
                    this.ordenarNombreOperario = 0;

                    function compareOperario(a, b) {
                        if (a.nombreOperario > b.nombreOperario) return -1;
                        if (a.nombreOperario < b.nombreOperario) return 1;
                        return 0;
                    }

                    return this.list.sort(compareOperario);
                case 12:
                    this.ordenarImporteIVA = 0;

                    function compareImporteIVA(a, b) {
                        if (a.importeIVA > b.importeIVA) return -1;
                        if (a.importeIVA < b.importeIVA) return 1;
                        return 1;
                    }

                    return this.list.sort(compareImporteIVA);

                case 13:
                    this.ordenarId = 0;
                    function compareIdentificadorContable(a, b) {
                        if (parseInt(a.identificador) > parseInt(b.identificador))
                            return -1;
                        if (parseInt(a.identificador) < parseInt(b.identificador)) return 1;
                        return 1;
                    }

                    return this.list.sort(compareIdentificadorContable);

                case 14:
                    this.ordenarPago = 0;

                    function comparePendientePago(a, b) {
                        if (a.pendientePago === b.pendientePago) {
                            return 0;
                        }
                        if (a.pendientePago) {
                            return -1;
                        }
                        return 1;
                    }

                    return this.list.sort(comparePendientePago);

                case 15:
                    this.ordenarVencimiento = 0;

                    function compareVencimiento(a, b) {
                        if (
                            a.dateVencimiento.toUpperCase() > b.dateVencimiento.toUpperCase()
                        )
                            return -1;
                        if (
                            a.dateVencimiento.toUpperCase() < b.dateVencimiento.toUpperCase()
                        )
                            return 1;
                        return 0;
                    }

                    return this.list.sort(compareVencimiento);

                case 16:
                    this.ordenarEntrAlmac = 0;

                    function compareAlmacen(a, b) {
                        if (a.generateWarehouse > b.generateWarehouse) return -1;
                        if (a.generateWarehouse < b.generateWarehouse) return 1;
                        return 0;
                    }

                    return this.list.sort(compareAlmacen);
            }
        },

        rutas(ruta, obj) {
            if (ruta === 1) {
                this.$router.push({
                    name: "gestion-gasto",
                    params: {
                        idBusiness: this.idBusiness,
                        idGasto: obj.idHeader,
                        vista: 1,
                    },
                });
            } else if (ruta === 2) {
                this.$router.push({
                    name: "gestion-gasto",
                    params: { idBusiness: this.idBusiness, idGasto: obj.idHeader },
                });
            } else if (ruta === 3) {
                this.$router.push({
                    name: "gestion-gasto",
                    params: {
                        idBusiness: this.idBusiness,
                        idGasto: obj.idHeader,
                        vista: 2,
                    },
                });
            }
        },

        getAffectedBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getBussinessAffected", config)
                .then(function (response) {
                    vm.listBusinesses = response.data.result;

                    vm.idBusiness = response.data.result[0].idBusiness;

                    vm.getGastosAfectados()                    

                })
                .catch(function (error) {
                    console.log(error);
                    vm.loadingGeneral.close();
                });
        },

        // getProveedores() {
        //     const controller = "getSuppliersByBusiness";
        //     var config = {
        //         params: {
        //             pag: 0,
        //             idBusiness: this.idBusiness,
        //             jwt: this.$store.getters.jwt,
        //         },
        //         headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        //     };
        //     this.$store.dispatch("setIdBusiness", this.idBusiness);

        //     let vm = this;
        //     this.axios
        //         .get(this.$store.getters.apiUrl + "suppliers/" + controller, config)
        //         .then(function (response) {
        //             if (response.data.response) {
        //                 if (response.data.result.suppliers.length === 0) {
        //                     let proveedor = {
        //                         name: vm.$t("todos"),
        //                         id: 0,
        //                     };

        //                     vm.listProveedores.push(proveedor);
        //                 }

        //                 for (let i = 0; i < response.data.result.suppliers.length; i++) {
        //                     if (i === 0) {
        //                         let proveedor = {
        //                             name: vm.$t("todos"),
        //                             id: 0,
        //                         };

        //                         vm.listProveedores.push(proveedor);
        //                     }

        //                     let proveedorname = {
        //                         name: response.data.result.suppliers[i].name,
        //                         id: response.data.result.suppliers[i].id,
        //                     };

        //                     vm.listProveedores.push(proveedorname);
        //                 }

        //                 vm.getGastosNegocio();
        //             } else {
        //                 vm.respuesta = false;
        //                 vm.loadingGeneral.close();
        //                 swal({
        //                     title: vm.$t("atencion"),
        //                     text: response.data.message,
        //                     confirmButtonClass: "btn btn-info btn-fill",
        //                     type: "error",
        //                 });
        //             }
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //         });
        // },

        // getGastosNegocio() {
        //     if (this.datefrom === null || this.dateto === null) {
        //         swal({
        //             title: this.$t("ups"),
        //             text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
        //             confirmButtonClass: "btn btn-info btn-fill",
        //             type: "error",
        //         });
        //     } else {
        //         let secondsDesde = moment(this.datefrom).unix();
        //         let secondsHasta = moment(this.dateto).unix();

        //         if (secondsHasta < secondsDesde) {
        //             swal({
        //                 title: this.$t("ups"),
        //                 text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
        //                 confirmButtonClass: "btn btn-info btn-fill",
        //                 type: "error",
        //             });
        //         } else {
        //             this.loading = true;
        //             this.$store.dispatch("setDateTo", this.dateto);
        //             this.$store.dispatch("setDateFrom", this.datefrom);

        //             var config = {
        //                 params: {
        //                     idBusiness: this.idBusiness,
        //                     mode: this.mode,
        //                     datefrom: moment(this.datefrom).startOf("day").unix(),
        //                     dateto: moment(this.dateto).endOf("day").unix(),
        //                     procedencia: this.procedencia,
        //                     filtrarPorFecha: this.filtrarPorFecha,
        //                     idSupplier: this.idSupplier,
        //                     jwt: this.$store.getters.jwt,
        //                 },

        //                 headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        //             };

        //             let vm = this;
        //             this.axios
        //                 .get(this.$store.getters.apiUrl + "gastos/getExpenses", config)
        //                 .then(function (response) {
        //                     vm.loadingGeneral.close();
        //                     vm.loading = false;

        //                     vm.list = [];

        //                     if (response.data.response) {
        //                         var xlist = [];

        //                         if (vm.contabilizado === -1) {
        //                             xlist = response.data.result;
        //                         } else {
        //                             for (let i = 0; i < response.data.result.length; i++) {
        //                                 if (
        //                                     vm.contabilizado === response.data.result[i].contabilizado
        //                                 ) {
        //                                     xlist.push(response.data.result[i]);
        //                                 }
        //                             }
        //                         }

        //                         var xlistTipo = [];

        //                         if (vm.tipo === 0) {
        //                             xlistTipo = xlist;
        //                         } else {
        //                             for (let i = 0; i < xlist.length; i++) {
        //                                 if (vm.tipo === xlist[i].type) {
        //                                     xlistTipo.push(xlist[i]);
        //                                 }
        //                             }
        //                         }

        //                         var xlistFormaPago = [];
        //                         if (vm.formaPago === -1) {
        //                             xlistFormaPago = xlistTipo;
        //                         } else {
        //                             for (let i = 0; i < xlistTipo.length; i++) {
        //                                 if (vm.formaPago === xlistTipo[i].formaPago) {
        //                                     xlistFormaPago.push(xlistTipo[i]);
        //                                 }
        //                             }
        //                         }

        //                         var xlistPendientePago = [];

        //                         if (vm.pendientePago === -1) {
        //                             xlistPendientePago = xlistFormaPago;
        //                         } else {
        //                             for (let i = 0; i < xlistFormaPago.length; i++) {
        //                                 if (vm.pendientePago === xlistFormaPago[i].pendientePago) {
        //                                     xlistPendientePago.push(xlistFormaPago[i]);
        //                                 }
        //                             }
        //                         }

        //                         if (vm.verificado === -1) {
        //                             vm.list = xlistPendientePago;
        //                         } else {
        //                             for (let i = 0; i < xlistPendientePago.length; i++) {
        //                                 if (vm.verificado === xlistPendientePago[i].verificado) {
        //                                     vm.list.push(xlistPendientePago[i]);
        //                                 }
        //                             }
        //                         }

        //                         vm.getConfigIdentificador();
        //                         vm.respuesta = true;
        //                     } else {
        //                         swal({
        //                             title: vm.$t("error"),
        //                             text: response.data.message,
        //                             confirmButtonClass: "btn btn-info btn-fill",
        //                             type: "error",
        //                         });
        //                         vm.respuesta = false;
        //                         // vm.$router.push({ name: 'informes'});
        //                     }
        //                 })
        //                 .catch(function (error) {
        //                     console.log(error);
        //                     vm.loadingGeneral.close();
        //                 });
        //         }
        //     }
        // },

        getGastosAfectados(){
            console.log("id" ,this.idBusiness);
            var config = {
            params: {
              idBusiness: this.idBusiness,
              jwt: this.$store.getters.jwt,
            },

            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;

          this.axios
            .get(this.$store.getters.apiUrl + "general/getDataAffectedByBussiness", config)
            .then(function (response) {
                vm.loadingGeneral.close();
                vm.loading = false;

                vm.list = [];

                vm.listAffectedGastos = response.data.result;


            })
        },

        modalverificar(obj) {
            swal({
                title: this.$t("estaSeguroDeVerificarEsteGasto"),
                text: this.$t("estaOperacionNoSePuedeDeshacer"),
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("siVerficarGasto"),
                cancelButtonText: this.$t("cancelar"),
                buttonsStyling: true,
            }).then((result) => {
                if (result.value) {
                    this.verificarGasto(obj);
                }
            });
        },
        modaleliminar(obj) {
            swal({
                title: this.$t("estasSeguroDeEliminarElGasto"),
                text: this.$t("estaOperacionNoSePuedeDeshacer"),
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("siEliminarGasto"),
                cancelButtonText: this.$t("cancelar"),
                buttonsStyling: true,
            }).then((result) => {
                if (result.value) {
                    this.eliminarGasto(obj);
                }
            });
        },

        verificarGasto(obj) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
                jwt: this.$store.getters.jwt,
                idHeader: obj.idHeader,
                idBusiness: this.idBusiness,
            };

            let vm = this;
            let controller = "verificarExpense";
            this.axios
                .post(
                    this.$store.getters.apiUrl + "gastos/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t("gastoVerificadoCorrectamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                        if (response.data.result != "") {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.result,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "info",
                            });
                        }

                        vm.getGastosNegocio();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
        },

        verificarTodosLosGastos() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
                jwt: this.$store.getters.jwt,
                idBusiness: this.idBusiness,
            };

            let vm = this;
            let controller = "verificarAllExpenses";
            this.axios
                .post(
                    this.$store.getters.apiUrl + "gastos/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t("gastosVerificadosCorrectamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });

                        vm.getGastosNegocio();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
        },

        contabilizar(p) {
            if (p.fromCash == 0) {
                if (p.contabilizado == 0) {
                    p.contabilizado = 1;
                } else {
                    p.contabilizado = 0;
                }
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };
                var params = {
                    jwt: this.$store.getters.jwt,
                    idHeader: p.idHeader,
                    contabilizado: p.contabilizado,
                    idBusiness: this.idBusiness,
                };

                let vm = this;
                let controller = "changeContabilizado";
                this.axios
                    .post(
                        this.$store.getters.apiUrl + "gastos/" + controller,
                        params,
                        config
                    )
                    .then(function (response) {
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t("contabilizadoCambiadoCorrectamente"),
                                icon: "nc-icon nc-check-2",
                                timeout: 2000,
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },

        updateExportadoSage(g) {
            this.textoPregunta =
                g.exportadoSage === 0
                    ? this.$t("askUpdateExportadoSageTrue")
                    : this.$t("askUpdateExportadoSageFalse");
            swal({
                title: this.$t("titleModificarExportadoSage"),
                text: this.textoPregunta,
                type: "info",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("si"),
                cancelButtonText: this.$t("cancelar"),
                buttonsStyling: true,
            }).then((result) => {
                if (result.value) {
                    var config = {
                        params: {
                            jwt: this.$store.getters.jwt,
                        },
                        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                    };
                    var params = {
                        jwt: this.$store.getters.jwt,
                        idHeader: g.idHeader,
                        exportadoSage: g.exportadoSage ? 0 : 1,
                        idBusiness: this.idBusiness,
                    };

                    let vm = this;
                    let controller = "updateExportadoSage";
                    this.axios
                        .post(
                            this.$store.getters.apiUrl + "gastos/" + controller,
                            params,
                            config
                        )
                        .then(function (response) {
                            if (response.data.response) {
                                alert(g.exportadoSage);
                                g.exportadoSage = g.exportadoSage === 0 ? 1 : 0;
                                alert(g.exportadoSage);

                                vm.$notify({
                                    message: vm.$t("updateExportadoSageCorrectamente"),
                                    icon: "nc-icon nc-check-2",
                                    timeout: 2000,
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: "success",
                                });
                            } else {
                                swal({
                                    title: vm.$t("atencion"),
                                    text: response.data.message,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "error",
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                            vm.inProgress = false;
                        });
                }
            });
        },

        eliminarGasto(g) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            var params = {
                jwt: this.$store.getters.jwt,
                idHeader: g.idHeader,
                idBusiness: this.idBusiness,
            };

            let vm = this;
            let controller = "deleteExpense";
            this.axios
                .post(
                    this.$store.getters.apiUrl + "gastos/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t("gastoEliminadoCorrectamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                        vm.getGastosNegocio();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
        },
        openInventario(idHeader) {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                    idHeader: idHeader,
                    idBusiness: this.idBusiness,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            let controller = "openInventario";
            this.axios
                .get(this.$store.getters.apiUrl + "gastos/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        if (response.data.result.length > 0) {
                            vm.inventario.subproducts = response.data.result;
                            vm.inventario.ivaIncluded = response.data.result[0].ivaIncluded;
                        } else {
                            vm.inventario.subproducts = [];
                            vm.inventario.ivaIncluded = 0;
                        }

                        vm.$modal.show("modal-open-inventario");
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
        },
        cerrarModal() {
            this.formaDePagoDeConversion = null;
            this.$modal.hide("modal-seleccionar-forma-pago");
            this.$modal.hide("modal-open-inventario");
            this.$modal.hide("modal-convertir-albaran");
            this.$modal.hide("modal-albaranes-de-factura");
        },
        pagar(p) {
            if (p.fromCash == 0) {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };
                var params = {
                    jwt: this.$store.getters.jwt,
                    idHeader: p.idHeader,
                    pendientePago: p.pendientePago ? 0 : 1,
                    idBusiness: this.idBusiness,
                };

                let vm = this;
                let controller = "changePendientePago";
                this.axios
                    .post(
                        this.$store.getters.apiUrl + "gastos/" + controller,
                        params,
                        config
                    )
                    .then(function (response) {
                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t("pendientePagoCambiadoCorrectamente"),
                                icon: "nc-icon nc-check-2",
                                timeout: 2000,
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });

                            p.pendientePago = !p.pendientePago;
                            vm.getGastosNegocio();
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            }
        },
        editarVencimiento(obj) {
            this.fechaVencimiento = "";
            let fecha;
            if (parseInt(obj.dateVencimiento) > 0) {
                fecha = new Date(parseInt(obj.dateVencimiento) * 1000);
            } else {
                fecha = new Date();
            }
            this.fechaVencimiento = fecha.toISOString();
            obj.editVencimiento = !obj.editVencimiento;
        },
        saveVencimiento(obj) {
            obj.dateVencimiento = moment(this.fechaVencimiento).unix() + "";
            this.loading = Loading.service({ text: this.$t("guardandoGasto") });

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
                jwt: this.$store.getters.jwt,
                idBusiness: this.idBusiness,
                idHeader: obj.idHeader,
                dateVencimiento: obj.dateVencimiento,
            };

            let vm = this;
            let controller = "editDateVencimiento";
            this.axios
                .post(
                    this.$store.getters.apiUrl + "gastos/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    vm.loading.close();

                    if (response.data.response) {
                        let notify = vm.$t("actualizado");
                        vm.$notify({
                            message:
                                vm.$t("gasto") + " " + notify + " " + vm.$t("correctamente"),
                            icon: "nc-icon nc-check-2",
                            timeout: 2000,
                            horizontalAlign: "right",
                            verticalAlign: "top",
                            type: "success",
                        });
                        obj.editVencimiento = !obj.editVencimiento;
                        vm.fechaVencimiento = "";
                        // vm.getGastosNegocio();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message,
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    vm.loading.close();
                    vm.inProgress = false;
                });
        },
        //LOLO
        closeContModal() {
            this.$modal.hide("modal-conta");
        },
        openConModal() {
            this.$modal.show("modal-conta");
        },
        exportConta() {
            let vm = this;
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            this.axios
                .get(
                    this.$store.getters.apiUrl +
                    "exportacionSage/getMaxIdentificadorContableByIdTpv",
                    config
                )
                .then(function (response) {
                    if (
                        response.data.result.topId >= idStart.value.replace(".", "") &&
                        response.data.result.topId >= idEnd.value.replace(".", "")
                    ) {
                        vm.exportCont();
                    } else {
                        swal({
                            title: vm.$t("atencion"),
                            text: response.data.message = "El máximo identificador contable que existe es " + response.data.result.topId + " ponga el identificador contable más bajo",
                            confirmButtonClass: "btn btn-info btn-fill",
                            type: "error",
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        exportCont() {
            if (
                idStart.value.replace(".", "") == "" ||
                idEnd.value.replace(".", "") == "" ||
                idStart.value.replace(".", "") == undefined ||
                idEnd.value.replace(".", "") == undefined
            ) {
                swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            } else if (idStart.value.replace(".", "") <= idEnd.value.replace(".", "")) {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idContableStart: idStart.value.replace(".", ""),
                        idContableEnd: idEnd.value.replace(".", ""),
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

                this.axios
                    .get(
                        this.$store.getters.apiUrl +
                        "exportacionSage/exportarSAGEAsientosContablesAutomaticoByIdContable",
                        config
                    )
                    .then(function (response) {
                        download(response.data, "sage.txt", "text/plain");
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                this.$modal.hide("modal-conta");
            } else {
                swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            }
        },
        
        saveGasto(obj){
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            const requestBody = {
                idGasto : obj.idGasto,
                importe: obj.importe
            }

            console.log("body",requestBody);

            let vm = this;

            this.axios
                .post(this.$store.getters.apiUrl + "general/updateImporteAffected", requestBody, config)
                .then(function (response) {
                    if (response){
                                vm.$notify({
                                    message: 'Gasto actualizado correctamente',
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });
                    }
                })
        
        }
    },
};
</script>

<style scoped>
p {
    list-style: none;
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    outline: none;
}

.cursor {
    color: #428bca;
    cursor: pointer;
}

.cursor:hover {
    text-decoration: underline;
}

p:hover {
    background-color: #ecf5ff;
}

a li {
    color: #111;
}

.card {
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/GastosPerdidos/GastosPerdidos.vue